import React, { Suspense } from 'react'

function RouteFallback() {
  return (
    <div className="min-h-[40vh] flex items-center justify-center text-gray-500" aria-live="polite">
      Loading…
    </div>
  )
}

export function RouteSuspense({ children }) {
  return <Suspense fallback={<RouteFallback />}>{children}</Suspense>
}
